import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { class: "fl" }
const _hoisted_3 = { class: "fw600 fs12 mt4" }
const _hoisted_4 = { class: "fw400 fs10 mt4" }
const _hoisted_5 = { class: "fw400 fs11 mt4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!

  return (_ctx.mf)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`w100 pad5 ${_ctx.mfindex % 2 == 0 ? `llgreyBg` : ``}`),
          style: {"height":"70px"}
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.mf.subject || _ctx.truncate("メールタイトルなし", 10)), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.sendToText) + "宛に", 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.timingText) + _toDisplayString(_ctx.timingMinWithUnit) + _toDisplayString(_ctx.mf.send_timing_around == `before` ? `前` : `後`) + "に送信 ", 1),
            _hoisted_6
          ]),
          _createElementVNode("p", {
            class: "fr pointer mt2",
            style: {"width":"14px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeCustomMf(_ctx.mf)))
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
              width: "14",
              height: "17"
            }, null, 8, _hoisted_7)
          ]),
          _createVNode(_component_Switcher, {
            value: "type[active]",
            name: "無効",
            checked: _ctx.mf.is_active,
            display: "true",
            class: "checkUsingCal fr mt10 mr10",
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActive(_ctx.mf)))
          }, null, 8, ["checked"]),
          _createElementVNode("span", {
            class: "circle_button fr skyblueBg rad4 fs11 mt12 mr10",
            style: {"padding":"4px 8px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editContent(_ctx.mf)))
          }, " 編集 "),
          _createElementVNode("span", {
            class: "fr skyblue rad4 fs11 mt12 mr10 pointer",
            style: {"padding":"4px 8px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPreview(_ctx.mf)))
          }, " プレビュー "),
          _hoisted_8
        ], 2)
      ]))
    : _createCommentVNode("", true)
}